import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { UserService } from '../../../services-http/user/user.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.scss']
})
export class UpdateProfileComponent implements OnInit {

  profileForm: FormGroup;
  User = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private fb: FormBuilder,
    private userService: UserService, 
    private spinner: NgxSpinnerService,
      private router: Router,
  ) {}

  ngOnInit(): void {
    this.profileForm = this.fb.group({
      firstname: ['', Validators.required],
      middlename: [''],
      lastname: ['', Validators.required],
      contactno: ['', [Validators.required, Validators.pattern(/^[0-9]{10,11}$/)]],
      designation: ['',Validators.required],
      coop: [this.User.coop_name,Validators.required],

    });
  }

  onSubmit(): void {
    
    this.spinner.show()

    let data = {
      firstname: this.profileForm.value.firstname,
      middlename: this.profileForm.value.middlename,
      lastname: this.profileForm.value.lastname,
      contact: this.profileForm.value.contactno,
      address: this.User['address'],
      coop_maincode: this.User['coop_maincode'],
      usertype: this.User['usertype'],
      tbl_cac_gam_agents_id : this.User['agentUnder'],
      username : this.User['username'],
      designation : this.profileForm.value.designation,
    }
       
    this.userService.updateUserInfo(this.User.iloginId, data).subscribe(res => {
      this.spinner.hide();
    
      Swal.fire(
        'Success',
        res['msg'],
        'success'
      );
 
      if (this.User['usertype'] == '1') {
        this.router.navigateByUrl('/admin/homepage');
      } else if (this.User['usertype'] == '3') {
        this.router.navigateByUrl('/gam/homepage');
      } else if (this.User['usertype'] == '4') {
        this.router.navigateByUrl('/cac/homepage');
      } else if (this.User['usertype'] == '5') {
        this.router.navigateByUrl('/agent/homepage');
      } else if (this.User['usertype'] == '6') {
        this.router.navigateByUrl('/coop/homepage');
      } else if (this.User['usertype'] == '7') {
        this.router.navigateByUrl('/endorsement-officer/homepage');
      } else if (this.User['usertype'] == '8') {
        this.router.navigateByUrl('/DQC-officer/homepage');
      } else if (this.User['usertype'] == '9') {
        this.router.navigateByUrl('/quotation-approval-officer/homepage');
      } else if (this.User['usertype'] == '10') {
        this.router.navigateByUrl('/cashin-approval-officer/homepage');
      } else if (this.User['usertype'] == '11') {
        this.router.navigateByUrl('/claims-officer/homepage');
      } else if (this.User['usertype'] == '12') {
        this.router.navigateByUrl('/user-management-officer/homepage');
      } else if (this.User['usertype'] == '13') {
        this.router.navigateByUrl('/renewalOfficer/homepage');
      } else if (this.User['usertype'] == '14') {
        this.router.navigateByUrl('/cashier/homepage');
      } else if (this.User['usertype'] == '15') {
        this.router.navigateByUrl('/reporter/homepage');
      } else if (this.User['usertype'] == '16') {
        this.router.navigateByUrl('/climbs-branch/homepage');
      } 
      else{
        alert("User type not available. Contact support!");
      }
      
    },error=>{
      this.spinner.hide();
    
      let err=error.error;
      let msg='';
    
      Object.keys(err).forEach(function(key){
        msg+=err[key]+'<br/>';
      })
    
      Swal.fire(
        'Oppss',
        msg,
        'error'
      );
    });
      


  }

}
